// extracted by mini-css-extract-plugin
module.exports = {"jobCard":"JobCard_jobCard__2Wvso"};